module.exports = __webpack_public_path__ + "static/media/privacy_anonymous.d96eca63.png";